<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix class="lbl">
      <mat-icon>close</mat-icon>
    </span>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <ngx-extended-pdf-viewer
      [base64Src]="data.imageSource"
      backgroundColor="#ffffff"
      [height]="'90vh'"
      [useBrowserLocale]="true"
      [handTool]="false"
      [showHandToolButton]="true"
    >
    </ngx-extended-pdf-viewer>
  </div>
</div>
